// extracted by mini-css-extract-plugin
export default {"modal":"FIIsFilterForm_modal__dZ7gG","slide-down":"FIIsFilterForm_slide-down__zStjb"};